function updateMediaItemsVisibility() {
    const thumbnailVariant = document.querySelector('.thumbnail-list__item.slider__slide');
    if (thumbnailVariant) {
        const thumbnailVariantValue = thumbnailVariant.getAttribute('thumbnail-variant');
        const mediaItems = document.querySelectorAll('.product__media-item.grid__item.slider__slide');
        mediaItems.forEach(item => {
            const mediaAlt = item.getAttribute('data-media-alt');
            if (mediaAlt !== 'generic' && mediaAlt !== thumbnailVariantValue) {
                item.style.display = 'none';
            } else {
                item.style.display = '';
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', updateMediaItemsVisibility);
window.updateMediaItemsVisibility = updateMediaItemsVisibility;